export const API_URL = process.env.REACT_APP_BACKEND || process.env.REACT_APP_BACKEND_ENV;

if (!API_URL) {
  throw new Error('API_URL is not defined!');
}

// eslint-disable-next-line no-console
console.log('%c API_URL:', 'color: #fff; background: #638BD9;', API_URL);
